<div
  class="gw-max-h-[min(75vh,36rem)] gw-overflow-auto gw-text-left gw-bg-white gw-rounded-lg gw-p-3"
>
  <ngx-json-viewer [json]="jsonData"></ngx-json-viewer>
</div>
